import React, { Component } from 'react'
import { Button, ButtonToolbar, Modal, FormControl } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import WorkdocStore from 'stores/WorkdocStore'
import DatePicker from 'component/element/DatePicker'
import NotificationSystem  from 'component/element/NotificationSystem'
import Moment from 'moment'


const TODAY = Moment().format('L').replace(Moment().format('YYYY'), parseInt(Moment().format('YYYY')) + 543)
class WorkPostponeAppointmentButton extends Component {
    constructor(props) {
      super(props)
      
      this.state = {show:false,data:[],masterData:[],loading:false,newrow:false}
    }
  
    componentDidMount() {
        // this.loadData()
    }

    loadData() {
        WorkdocStore.loadAppointmentRecord(this.props.workNo,(result)=>{
            this.setState({data:result.data,masterData:result.data})
        })
    }

    newEmptyRow(number) {
        let {data} = this.state
        let appointment_date = ''
        if (data.length>0) {
            appointment_date = data[data.length-1].new_appointment_date
        }
        return new Array(number).fill(null).map((item, index) => {
          return {bf_record_id:'',added_by:'',appointment_date:appointment_date,approved_by:'',detail:'',new_appointment_date:'',record_date:TODAY}
        })
    }

    onRowAdd(number) {
        let {data,masterData} = this.state
        if (data.length==masterData.length) {
            if (data.length>0)
                data = data.concat(this.newEmptyRow(number))
            else
                data = this.newEmptyRow(number)
            
            this.setState({data:data,newrow:true})
        }    
    }

    onDateChange(index,key,e) {
        let {data} = this.state
        data[index][key] = e
        this.setState({data:data})
    }

    onTextChange(index,key,e) {
        let {data} = this.state
        data[index][key] = e.target.value
        this.setState({data:data})
    }

    onModalShow() {
        this.setState({show:true,newrow:false},()=>{
            this.loadData()
        })
    }

    onSaveClick() {
        let {data} = this.state
        if (data.length>0) {            
            let newItem = data[data.length-1]
            if(newItem.detail=='' || newItem.approved_by==''){
                this.refs.notificationSystem.addNotification({
                    title:'แจ้งเตือน',
                    message: 'โปรดระบุเหตุผล และผู้อนุมัติการเลื่อนนัด',
                    level: 'error',
                    position:'tc'
                });
                return;
            }
            let postData = Object.assign({work_no:this.props.workNo},newItem)
            WorkdocStore.saveAppointmentRecord(postData,(result)=>{
                if (result.status=='OK') {
                    this.refs.notificationSystem.addNotification({
                        title:'แจ้งเตือน',
                        message: 'ทำการบันทึกเรียบร้อย',
                        level: 'info',
                        position:'tc'
                    });
                    newItem.bf_record_id = result.bf_record_id
                    this.setState({data:data,masterData:data,show:false})
                    if(this.props.onSave!==undefined){
                        this.props.onSave(postData)
                    }
                }
            },()=>{

            })
        }    
    }

    renderRowData() {
        let {data} = this.state
        if (data.length==0) {
            return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
        } else {
            return(
                data.map((item,index)=> {
                    let isDisabled = true
                    if (item.bf_record_id=='')
                        isDisabled = false
                    
                    return(
                        <tr key={index} style={{background:(isDisabled?'rgb(249, 249, 249)':'')}}>
                            <td className='text-center'>{index+1}</td>
                            <td className='text-center'>
                                <DatePicker
                                    disabledCalendarIcon={true}
                                    disabled={true}
                                    showIcon={true}
                                    showFooter={true}
                                    popPlacement='bottom'
                                    buddhistEra
                                    value={item.record_date}
                                    onChange={this.onDateChange.bind(this,index,'record_date')}
                                    maxWidth={'100%'}
                                />
                            </td>
                            <td className='text-center'>
                                <DatePicker
                                    disabledCalendarIcon={isDisabled}
                                    disabled={isDisabled}
                                    showIcon={true}
                                    showFooter={true}
                                    popPlacement='bottom'
                                    buddhistEra
                                    value={item.appointment_date}
                                    onChange={this.onDateChange.bind(this,index,'appointment_date')}
                                    maxWidth={'100%'}
                                />
                            </td>
                            <td className='text-center'>
                                <DatePicker
                                    disabledCalendarIcon={isDisabled}
                                    disabled={isDisabled}
                                    showIcon={true}
                                    showFooter={true}
                                    popPlacement='bottom'
                                    buddhistEra
                                    value={item.new_appointment_date}
                                    onChange={this.onDateChange.bind(this,index,'new_appointment_date')}
                                    maxWidth={'100%'}
                                />
                            </td>
                            <td className='text-left'>
                                <FormControl
                                    disabled={isDisabled}
                                    value={item.detail}
                                    onChange={this.onTextChange.bind(this,index,'detail')}
                                />
                            </td>
                            <td className='text-center'>
                                <FormControl
                                    disabled={isDisabled}
                                    value={item.approved_by}
                                    onChange={this.onTextChange.bind(this,index,'approved_by')}
                                />
                            </td>
                            <td className='text-center'>
                                {item.added_by}
                            </td>
                        </tr>
                    )
                })    
            )
        }
    }

    renderTable() {
        return(
            <div className='table-responsive'>
                <table className='table table-responsive table-bordered-solid table-report-kkc-income' style={{marginBottom:'0'}}>
                    <thead>
                        <tr>
                            <th className='text-center' style={{width:'50px'}}>ลำดับ</th>
                            <th className='text-center' style={{width:'180px'}}>วันลงข้อมูล</th>
                            <th className='text-center' style={{width:'180px'}}>วันนัดหมายเดิม</th>
                            <th className='text-center' style={{width:'180px'}}>วันนัดหมายใหม่</th>
                            <th className='text-center' style={{minWidth:'170px'}}>รายละเอียด</th>
                            <th className='text-center' style={{minWidth:'100px'}}>อนุมัติโดย</th>
                            <th className='text-center' style={{width:'100px'}}>ลงข้อมูลโดย</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderRowData()}
                    </tbody>
                </table>
            </div>
        )
    }

    renderNewItemButton() {
        let {newrow} = this.state
        return (
          <div style={{ display: 'inline-flex' }}>
            <ButtonToolbar>
              <Button style={{display:(newrow?'none':'')}} className='bg-olive' onClick={this.onRowAdd.bind(this, 1)}><FontAwesome name='plus' />&nbsp;เลื่อนนัดหมายรับรถ</Button>
            </ButtonToolbar>
          </div>
        )
      }

    render() {
        let {newrow} = this.state
        return(
            <div>
                <Button bsStyle='default' onClick={this.onModalShow.bind(this)}><FontAwesome className='text-red' name='calendar-plus-o' /></Button>
                <Modal bsSize='large' show={this.state.show} onHide={()=>{this.setState({show:false})}} dialogClassName="midwidth-dialog">
                    <Modal.Header closeButton>
                        <Modal.Title>ตารางการเลื่อนนัดหมายรับรถ</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.renderTable()}
                        {this.renderNewItemButton()}
                    </Modal.Body>
                    <Modal.Footer>
                        <div className='pull-right'>
                            <Button style={{display:(newrow?'':'none')}} bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;บันทึกเลื่อนนัด</Button>
                            <Button onClick={()=>{this.setState({show:false})}}><FontAwesome name='close' />&nbsp;ปิด</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
                <NotificationSystem ref="notificationSystem" />
            </div>    
        )
      }
    }
    
    WorkPostponeAppointmentButton.defaultProps = {
        onSave : ()=>{}
    }
      
    export default WorkPostponeAppointmentButton;      


// WEBPACK FOOTER //
// ./src/view/workdoc/WorkPostponeAppointmentButton.js